export const PHRASES_LOW_VALUE_THRESHOLD = 15;

export function getIsLowValue(value: number): boolean {
    return value > 0 && value < PHRASES_LOW_VALUE_THRESHOLD;
}
